/* eslint-disable @typescript-eslint/ban-ts-comment */
// Landing Page Data
// @ts-nocheck

import { ArticleApiResponse } from 'api/api.types';
import { Review } from 'types/types';
import { UserStash } from 'types/models';
import React from 'react';

// Reviews
export const LANDING_PAGE_REVIEWS: Review[] = [
  {
    id: 0,
    name: 'samz905',
    title: 'Amazing quick bites for the inquisitive!',
    text: 'Don’t look further if you love learning new things. A refreshing concept that provides quick ideas for busy thought leaders.',
    platform: 'ios',
    imageUrl: 'https://static.deepstash.com/profile/1.png',
  },
  {
    id: 1,
    name: 'Shankul Varada',
    text: 'Best app ever! You heard it right. This app has helped me get back on my quest to get things done while equipping myself with knowledge everyday.',
    platform: 'ios',
    imageUrl: 'https://static.deepstash.com/profile/3.png',
  },
  {
    id: 2,
    name: 'Ashley Anthony',
    text: 'This app is LOADED with RELEVANT, HELPFUL, AND EDUCATIONAL material. It is creatively intellectual, yet minimal enough to not overstimulate and create a learning block. I am exceptionally impressed with this app!',
    platform: 'ios',
    imageUrl: 'https://static.deepstash.com/profile/4.png',
  },
  {
    id: 3,
    name: 'Sean Green',
    text: 'Great interesting short snippets of informative articles. Highly recommended to anyone who loves information and lacks patience.',
    platform: 'ios',
    imageUrl: 'https://static.deepstash.com/profile/5.png',
  },
  {
    id: 4,
    name: 'Ghazala Begum',
    text: "Even five minutes a day will improve your thinking. I've come across new ideas and learnt to improve existing ways to become more motivated, confident and happier.",
    platform: 'android',
    imageUrl:
      'https://lh3.googleusercontent.com/a-/AOh14GjGXBdpXBkYWavU_Uy3PadRBt5l3aKV2hykiihLSA',
  },
  {
    id: 5,
    name: 'Giovanna Scalzone',
    text: 'Brilliant. It feels fresh and encouraging. So many interesting pieces of information that are just enough to absorb and apply. So happy I found this.',
    platform: 'android',
    imageUrl:
      'https://lh3.googleusercontent.com/a-/AOh14Gim03kWuEM_Hnc1RB0XaLF-N9TVHYIZT4NaN0XB7w',
  },
  {
    id: 6,
    name: 'Laetitia Berton',
    text: 'I have only been using it for a few days now, but I have found answers to questions I had never consciously formulated, or to problems I face everyday at work or at home. I wish I had found this earlier, highly recommended!',
    platform: 'android',
    imageUrl:
      'https://lh3.googleusercontent.com/a-/AOh14GiaxpWuIcuvSwV5Qng0f2F7CGGU6scPXWl1TZ77Lg',
  },
  {
    id: 7,
    name: 'Jamyson Haug',
    text: 'Great for quick bits of information and interesting ideas around whatever topics you are interested in. Visually, it looks great as well.',
    platform: 'android',
    imageUrl:
      'https://lh3.googleusercontent.com/a-/AOh14GimAQUHXLihNV5EZsOSmLA9BXGg-9kmoDNmV5kruA',
  },
];

export const LANDING_PAGE_IDEAS = [
  [
    {
      title: 'Habits are mental shortcuts',
      content: (
        <>
          <b>
            A habit is a routine or behavior that is carried out repeatedly and
            most of the time automatically.
          </b>
          <br />
          <br />
          When you are faced with a problem repeatedly, your brain starts to
          automate the process of solving it.{' '}
          <b>
            Your habits are sets of automatic solutions that solve the problems
            you come across regularly.
          </b>
        </>
      ),
    },
    {
      title: 'Focus on systems, not on goals',
      content: (
        <>
          <b>
            Goals are good for establishing a direction, but systems are best
            for making progress.
          </b>
          <br />
          <br />
          Goals are about the results you hope to reach. Systems are about the
          mechanisms that lead to those results.
        </>
      ),
    },
  ],
  [
    {
      title: 'Specialization is for Insects',
      content: (
        <>
          You have one life. We tend to define people by a few narrow
          identities, <b>but humans are broader then that.</b>
          <br />
          <br />
          We are creators, parents, partners etc. Putting people in boxes goes
          against human nature.
        </>
      ),
    },
    {
      title: 'Read for Understanding',
      content: (
        <>
          Books read is a vanity metric, a signal for intellect, but a weak one.
          <br />
          <br />
          You should <b>read books for understanding</b>. If a book looses your
          interest, drop it.
        </>
      ),
    },
  ],
  [
    {
      title: 'How To Read 1000 Books A Year?',
      content: (
        <>
          Reading thousands of books in a year isn't a tough job. To do this
          it's not necessary to be a smart or advanced reader. You just need to
          follow these steps:
          <br />
          <br />
          <ol>
            <li>Fill the funnel</li>
            <li>Make it effortless</li>
            <li>The blog post mindset</li>
            <li>Go deep</li>
          </ol>
        </>
      ),
    },
    {
      title: '1. Fill The Funnel',
      content: (
        <>
          If we wanto read more books, then we need to have loads and loads of
          books coming into the top of our funnel.
          <br />
          <br />
          This means when we have tonnes of books that we're checking out, and
          only later are we deciding, if it's the book that we're actually want
          to read properly.
          <br />
          <br />A simple way to start doing this is to start reading summaries
          of the books first and filter out what really connects to you!
        </>
      ),
    },
  ],
  [
    {
      title: 'What If Thoughts Came But Didn’t Go?',
      content: (
        <>
          <b>
            Imagine if you could take a pill that would double your
            intelligence. What would that feel like?
          </b>
          <br />
          <br />
          <b>
            You’d be able to keep more thoughts in your head. You could draw new
            connections between ideas. You could solve problems you’ve been
            stuck on for years.
          </b>
          <br />
          <br />
          Such a pill may not exist, but there already is a cognitive enhancing
          tool, and it doesn’t require brain-altering drugs.
        </>
      ),
    },
    {
      title: 'Intelligence, Our RAM And The n-Back Task',
      content: (
        <>
          <b>
            Cognitive scientists believe that working memory is one of the major
            components of intelligence. Working memory (WM) is like the RAM for
            your mind. It consists of all the things you’re keeping in mind
            simultaneously.
          </b>
          <br />
          <br />A common test of working memory is the n-back task. In this
          test, experimenters will repeat a string of digits and then, at a
          random point, ask you to recall the input from n steps previously.
        </>
      ),
    },
  ],
  [
    {
      title: 'The Pleasure Of Doomscrolling',
      content: (
        <>
          Humans are fascinated by bad news. The appeal of ‘wrong’ is a striking
          psychological phenomenon that baffles many researchers.
          <br />
          <br />
          Just like we cannot look away from a car accident happening in front
          of our eyes, doomscrolling or endlessly scrolling through news feeds
          and social media content can feel soothing.
        </>
      ),
    },
    {
      title: 'Sucked In A Vortex Of Information',
      content: (
        <>
          Doomscrolling is a modern equivalent of the late-night 11 o’clock news
          that many families watched before going to sleep.
          <br />
          <br />
          People find a topic and then get sucked in a vortex of information,
          provided by never-ending news cycles.
          <b>
            We are biologically driven towards attending to our worried mind and
            searching for answers about the things we are afraid of.
          </b>
        </>
      ),
    },
  ],
];

// Sources
export const LANDING_PAGE_SOURCES: ArticleApiResponse[] = [
  {
    author: 'James Clear',
    blocks: [],
    content: '',
    context: '',
    created_at: '2022-01-11T05:23:56.884433',
    description:
      "The #1 New York Times bestseller. Over 3 million copies sold! Tiny Changes, Remarkable Results No matter your goals, Atomic Habits offers a proven framework for improving--every day. James Clear, one of the world's leading experts on habit formation, reveals practical strategies that will teach you exactly how to form good habits, break bad ones, and master the tiny behaviors that lead to remarkable results. If you're having trouble changing your habits, the problem isn't you. The problem is your system. Bad habits repeat themselves again and again not because you don't want to change, but because you have the wrong system for change. You do not rise to the level of your goals. You fall to the level of your systems. Here, you'll get a proven system that can take you to new heights. Clear is known for his ability to distill complex topics into simple behaviors that can be easily applied to daily life and work. Here, he draws on the most proven ideas from biology, psychology, and neuroscience to create an easy-to-understand guide for making good habits inevitable and bad habits impossible. Along the way, readers will be inspired and entertained with true stories from Olympic gold medalists, award-winning artists, business leaders, life-saving physicians, and star comedians who have used the science of small habits to master their craft and vault to the top of their field. Learn how to: • make time for new habits (even when life gets crazy); • overcome a lack of motivation and willpower; • design your environment to make success easier; • get back on track when you fall off course; ...and much more. Atomic Habits will reshape the way you think about progress and success, and give you the tools and strategies you need to transform your habits--whether you are a team looking to win a championship, an organization hoping to redefine an industry, or simply an individual who wishes to quit smoking, lose weight, reduce stress, or achieve any other goal.",
    id: 35971,
    image:
      'https://books.google.com/books/content?id=XfFvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api',
    image_blurhash: 'L9RCrJ%h%Mxu%fMdozRQCTx[-ooy',
    image_compressed:
      'https://books.google.com/books/content?id=XfFvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api',
    image_preview: 'https://preview.deepstash.com/a/118080-1641958449.png',
    source_subtype: 0,
    source_type: 1,
    status: 3,
    suggested_hashtags: ['books'],
    title: 'Atomic Habits',
    top_reactions: [
      {
        reaction_id: 2,
        total_users: 172,
      },
      {
        reaction_id: 5,
        total_users: 10,
      },
      {
        reaction_id: 3,
        total_users: 6,
      },
    ],
    total_blocks: 15,
    total_comments: 7,
    total_likes: 613,
    total_reactions: 190,
    total_reads: 24091,
    total_saves: 8600,
    type: 1,
    updated_at: '2022-01-12T03:34:07.829084',
    url: 'https://books.google.com/books/about/Atomic_Habits.html?hl=&id=XfFvDwAAQBAJ',
    user_data: {
      bio: 'Life goes on ',
      first_name: 'Zankhu',
      has_profile: true,
      id: 1475761,
      image_preview: 'https://preview.deepstash.com/u/1475761-1642517985.png',
      last_name: 'G',
      photo:
        'https://d1dfxfqogsjixt.cloudfront.net/profile/1475761-1642517977.jpeg',
      photo_blurhash: 'LYJQ+qD4NGt,^+Dixaxaay%Ls.w{',
      subscription_type: 2,
      url: null,
      username: 'zankhu21',
    },
  },
  {
    author: 'PowerfulJRE',
    blocks: [],
    content:
      'Naval Ravikant is an entrepreneur and angel investor, a co-author of Venture Hacks, and a co-maintainer of AngelList.',
    context: null,
    created_at: '2020-12-10T12:54:54.507336',
    description:
      'Naval Ravikant is an entrepreneur and angel investor, a co-author of Venture Hacks, and a co-maintainer of AngelList.',
    id: 1701,
    image: 'https://i.ytimg.com/vi/3qHkcs3kG44/mqdefault.jpg',
    image_blurhash: 'LXIOFJR+01xtERslRjX8V@NGjYs.',
    image_compressed:
      'https://d3t70bohx4vuj7.cloudfront.net/5vPGnYESDLfolmHE9LRQYCtIUC31n_M8koGPYy_JzVM/resize:fill:500:0/gravity:sm/aHR0cHM6Ly9pLnl0aW1nLmNvbS92aS8zcUhrY3Mza0c0NC9tcWRlZmF1bHQuanBn',
    image_preview: 'https://preview.deepstash.com/a/1701-1624018537.png',
    source_subtype: 1,
    source_type: 3,
    stash_published_in: {
      description: null,
      emoji: '🌻',
      id: 678437,
      image: null,
      image_compressed: null,
      image_preview: 'https://preview.deepstash.com/s/678437-1624018660.png',
      name: 'Self Improvement',
      thematic: false,
      topics: [],
    },
    status: 3,
    suggested_blocks: [],
    title: 'The Joe Rogan Experience #1309 - Naval Ravikant',
    top_reactions: [
      {
        reaction_id: 2,
        total_users: 41,
      },
    ],
    total_blocks: 18,
    total_comments: 0,
    total_likes: 113,
    total_reactions: 41,
    total_reads: 5066,
    total_saves: 2490,
    type: 0,
    updated_at: '2021-03-10T16:23:26.119228',
    url: 'https://www.youtube.com/watch?v=3qHkcs3kG44',
    user_data: {
      bio: 'Believer of Peace, Follower of Happiness',
      first_name: 'Joanne',
      has_profile: true,
      id: 861580,
      image_preview: 'https://preview.deepstash.com/u/861580-1624018530.png',
      last_name: '(Jo)',
      photo: 'https://d1dfxfqogsjixt.cloudfront.net/profile/jojo_the2nd.png',
      photo_blurhash: 'LZIy:%t60z9u%L$*snEMS#ofayay',
      subscription_type: 2,
      url: null,
      username: 'jojo_thend',
    },
  },
  {
    author: 'Ali Abdaal',
    blocks: [],
    content:
      "In this video I'll be going over a few methods that allow me to read up to 1000 books every year. <br><br>✍️ The best summaries of books (Shortform) - https://go.aliabdaal.com/shortform<br>📚 My Goodreads profile: https://www.goodreads.com/user/show/45329045-ali-abdaal<br>🎧 Sign up to Audible here: https://audible.com/aliabdaal<br>🎞 Naval excerpt courtesy of Joe Rogan: https://www.youtube.com/watch?v=3qHkcs3kG44<br>📖 How to Read a Book: https://geni.us/HkStXXO<br><br>00:00 Intro<br>00:58 Fill the funnel<br>03:08 Make it effortless<br>05:13 The blog post mindset<br>07:29 Go deep<br><br>MY FREE ONLINE COURSES:<br>🚀  Productivity Masterclass - Principles and Tools to Boost Your Productivity - https://go.aliabdaal.com/course/productivity<br>🎬  Video Editing with Final Cut Pro X - From Beginner to YouTuber - https://go.aliabdaal.com/course/video-editing<br>🎓  How to Study for Exams - An Evidence-Based Masterclass - https://go.aliabdaal.com/course/studying<br><br>PART-TIME YOUTUBER ACADEMY:<br>🍿 My 6-week live online course - https://academy.aliabdaal.com<br><br>MY FAVOURITE GEAR:<br>🎥  My YouTube Camera Gear - https://kit.co/AliAbdaal<br>⌨️  My Keyboard - Wireless Coral mechanical keyboard (Cherry Blue) - https://go.aliabdaal.com/keyboard <br>📝  My favourite iPad Screen Protector - Paperlike - https://go.aliabdaal.com/paperlike <br>🎒 My Desk Accessories + Todo List - Ugmonk - https://go.aliabdaal.com/ugmonk<br><br>MY FAVOURITE SOFTWARE:<br>📚  How I remember what I read (Readwise) - https://go.aliabdaal.com/readwise <br>🎵  Where I get my Music (amazing for YouTubers) - https://go.aliabdaal.com/epidemicsound<br><br>🎙 My weekly podcast - https://www.notoverthinking.com<br>My brother and I host a weekly podcast where we discuss happiness, creativity and the human condition. You can find it by searching “Not Overthinking” on any podcast app (eg: Spotify, Apple Podcasts, Google Podcasts etc). <br><br>BE MY FRIEND:<br>💌  Sign up to my weekly email newsletter - https://aliabdaal.com/friendzone/<br>🌍  My website / blog - https://www.aliabdaal.com <br> <br>📸  Instagram - https://instagram.com/aliabdaal<br>🐦  Twitter - https://twitter.com/aliabdaal<br>🎮  Twitch - https://twitch.tv/aliabdaal<br><br>WHO AM I:<br>I'm Ali, a junior doctor working in Cambridge, UK. I make videos about medicine, technology, productivity and lifestyle design. I also have a weekly podcast with my brother (https://www.notoverthinking.com), and I write a weekly email newsletter that contains some quick thoughts + links to interesting things (https://email.aliabdaal.com).<br><br>🌍  My website / blog - https://www.aliabdaal.com <br><br>GET IN TOUCH:<br>If you’d like to talk, I’d love to hear from you. Tweeting @AliAbdaal directly will be the quickest way to get a response, but if your question is very long, feel free to email me at hi@aliabdaal.com. I try my best to reply to things but there sadly aren't enough hours in the day to respond to everyone 😭<br><br>PS: Some of the links in this description are affiliate links that I get a kickback from 😜",
    context: null,
    created_at: '2021-10-06T16:12:48.142480',
    description:
      "In this video I'll be going over a few methods that allow me to read up to 1000 books every year. <br><br>✍️ The best summaries of books (Shortform) - https://go.aliabdaal.com/shortform<br>📚 My Goodreads profile: https://www.goodreads.com/user/show/45329045-ali-abdaal<br>🎧 Sign up to Audible here: https://audible.com/aliabdaal<br>🎞 Naval excerpt courtesy of Joe Rogan: https://www.youtube.com/watch?v=3qHkcs3kG44<br>📖 How to Read a Book: https://geni.us/HkStXXO<br><br>00:00 Intro<br>00:58 Fill the funnel<br>03:08 Make it effortless<br>05:13 The blog post mindset<br>07:29 Go deep<br><br>MY FREE ONLINE COURSES:<br>🚀  Productivity Masterclass - Principles and Tools to Boost Your Productivity - https://go.aliabdaal.com/course/productivity<br>🎬  Video Editing with Final Cut Pro X - From Beginner to YouTuber - https://go.aliabdaal.com/course/video-editing<br>🎓  How to Study for Exams - An Evidence-Based Masterclass - https://go.aliabdaal.com/course/studying<br><br>PART-TIME YOUTUBER ACADEMY:<br>🍿 My 6-week live online course - https://academy.aliabdaal.com<br><br>MY FAVOURITE GEAR:<br>🎥  My YouTube Camera Gear - https://kit.co/AliAbdaal<br>⌨️  My Keyboard - Wireless Coral mechanical keyboard (Cherry Blue) - https://go.aliabdaal.com/keyboard <br>📝  My favourite iPad Screen Protector - Paperlike - https://go.aliabdaal.com/paperlike <br>🎒 My Desk Accessories + Todo List - Ugmonk - https://go.aliabdaal.com/ugmonk<br><br>MY FAVOURITE SOFTWARE:<br>📚  How I remember what I read (Readwise) - https://go.aliabdaal.com/readwise <br>🎵  Where I get my Music (amazing for YouTubers) - https://go.aliabdaal.com/epidemicsound<br><br>🎙 My weekly podcast - https://www.notoverthinking.com<br>My brother and I host a weekly podcast where we discuss happiness, creativity and the human condition. You can find it by searching “Not Overthinking” on any podcast app (eg: Spotify, Apple Podcasts, Google Podcasts etc). <br><br>BE MY FRIEND:<br>💌  Sign up to my weekly email newsletter - https://aliabdaal.com/friendzone/<br>🌍  My website / blog - https://www.aliabdaal.com <br> <br>📸  Instagram - https://instagram.com/aliabdaal<br>🐦  Twitter - https://twitter.com/aliabdaal<br>🎮  Twitch - https://twitch.tv/aliabdaal<br><br>WHO AM I:<br>I'm Ali, a junior doctor working in Cambridge, UK. I make videos about medicine, technology, productivity and lifestyle design. I also have a weekly podcast with my brother (https://www.notoverthinking.com), and I write a weekly email newsletter that contains some quick thoughts + links to interesting things (https://email.aliabdaal.com).<br><br>🌍  My website / blog - https://www.aliabdaal.com <br><br>GET IN TOUCH:<br>If you’d like to talk, I’d love to hear from you. Tweeting @AliAbdaal directly will be the quickest way to get a response, but if your question is very long, feel free to email me at hi@aliabdaal.com. I try my best to reply to things but there sadly aren't enough hours in the day to respond to everyone 😭<br><br>PS: Some of the links in this description are affiliate links that I get a kickback from 😜",
    id: 100470,
    image: 'https://i.ytimg.com/vi/XiGaXVJHwhc/mqdefault.jpg',
    image_blurhash: 'LMI=cC8|V;.T~pD%%3I.DiRiaLE0',
    image_compressed:
      'https://d3t70bohx4vuj7.cloudfront.net/aV0rcGZmSHIaL9Xtovi52TZ6z7qtukLa3oYlFg0nrmo/resize:fill:500:0/gravity:sm/aHR0cHM6Ly9pLnl0aW1nLmNvbS92aS9YaUdhWFZKSHdoYy9tcWRlZmF1bHQuanBn',
    image_preview: 'https://preview.deepstash.com/a/100470-1633538632.png',
    source_subtype: 1,
    source_type: 2,
    stash_published_in: {
      description: null,
      emoji: '📚',
      id: 2315228,
      image: null,
      image_compressed: '',
      image_preview: 'https://preview.deepstash.com/s/2315228-1623755169.png',
      name: 'Books',
      thematic: false,
      topics: [],
    },
    status: 3,
    suggested_blocks: [],
    title: 'How to ‘Read’ 1000 Books a Year',
    top_reactions: [
      {
        reaction_id: 2,
        total_users: 20,
      },
    ],
    total_blocks: 6,
    total_comments: 0,
    total_likes: 42,
    total_reactions: 20,
    total_reads: 1840,
    total_saves: 272,
    type: 0,
    updated_at: '2021-10-06T16:43:49.522565',
    url: 'https://youtu.be/XiGaXVJHwhc',
    user_data: {
      bio: '17 | A start-up guy, Content creator, soloprenuer and a podcaster. Founder, Blast. Building Snakcards and more.\nStashing about entrepreneurship, self-help, spirituality and the most interesting stuff I read.',
      first_name: 'Aditya',
      has_profile: true,
      id: 1136132,
      image_preview: 'https://preview.deepstash.com/u/1136132-1650491553.png',
      last_name: 'Mulukuri',
      photo:
        'https://d1dfxfqogsjixt.cloudfront.net/profile/1136132-1650491551.jpeg',
      photo_blurhash: 'LQG*NC={^%E3~9xZf5Ip9uIpM|WV',
      subscription_type: 2,
      url: 'https://expy.bio/adityamulukuri',
      username: 'adityamulukuri',
    },
  },
  {
    author: 'scotthyoung.com',
    blocks: [],
    content:
      '<p>Imagine if you could take a pill that would double your intelligence. What would that feel like?</p><p>You’d be able to keep more thoughts in your head. You could draw new connections between ideas. You could solve problems you’ve been stuck on for years.</p><p>Such a pill may not exist, but there already is a cognitive enhancing tool, and it doesn’t require brain-altering drugs.</p><h2>Writing to Think Better</h2><p>Writing your thoughts is the key to better thinking.</p><p>Cognitive scientists believe that working memory is one of the major components of intelligence. Working memory is like the RAM for your mind. It consists of all the things you’re keeping in mind simultaneously.</p><p dir="ltr">A common test of working memory is the <a href="https://en.wikipedia.org/wiki/N-back" dir="ltr">n-back task</a>. In this test, experimenters will repeat a string of digits and then, at a random point, ask you to recall the input from <em dir="ltr">n</em> steps previously.</p><img src="https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png" alt="How to Improve Your Thinking" width="745" height="631" srcset="https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png 800w, https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back-300x254.png 300w, https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back-768x651.png 768w"><p>This test is hard because the numbers you need to repeat back will keep changing. You need to hold all the current numbers in your head, without forgetting any of them.</p><p>People who can hold more numbers in their heads, have higher working memories and are often more intelligent generally. Being able to keep more things in mind at the same time is a big part of what makes some people smarter than others.</p><p>Now consider that, if one change to the test were made, performance would become almost perfect, even if the n-back test was asking for the last one hundred or ten thousand digits. That change? Allowing participants to write down the numbers as they hear them. Now reciting off huge lists of numbers is trivial, no matter the length.</p><h2>Paper as an Extension of Your Mind</h2><p>While writing may not literally increase your working memory, many cognitive scientists now believe that such external representations may form important parts of our cognition. This externalized cognition extends the space of thinking and literally makes us smarter, even if our brains are just the same as before.</p><p>Just as writing helps with numerical and mnemonic tasks, it can help you think more clearly about your life problems as well.</p><p dir="ltr"><strong dir="ltr">First, by jotting down your thoughts on paper, you can hold more ideas than you could in your limited working memory.</strong> This means you can more easily work through thoughts that have several parts which are difficult to keep in mind simultaneously.</p><p dir="ltr"><strong dir="ltr">Second, writing allows editing</strong>. If I write down an idea, then later notice a contradiction further down the page, I can go back and edit it. Editing mentally quickly becomes exhausting as, like in the n-back task, the old information interferes with the new.</p><p dir="ltr"><strong dir="ltr">Third, writing allows for longer thoughts.</strong> Have you ever had a conversation where, as you were listening, you forgot the point you were eager to make? Ideas bubble up and pop all the time in our minds, it’s only with writing that you can capture it.</p><h2>How to Start Thinking Better</h2><p>There’s a few ways you can improving your thinking with writing:</p><h3>1. Have a written meeting, before your face-to-face one.</h3><p>Are you going to discuss something with colleagues? Pretend the meeting isn’t happening and that you need to communicate your plans entirely via email. Draft up an email with your thoughts.</p><p>It doesn’t matter whether you send the email or not. Having thought through your ideas clearly, you’ll be able to communicate them intelligently when the meeting comes.</p><h3>2. Vexing problems should start with paper and pen.</h3><p>Are you struggling with an important problem in life or work? Your first instinct should be to get a piece of paper and start writing it down. Jot down all the elements of the problem, including all your different ideas for a solution.</p><p>Many problems which feel overwhelming are suddenly simplified once you write them down.</p><h3>3. Confusions are cleared up by writing down explanations.</h3><p dir="ltr">One of my most popular studying tactics was the <a href="https://www.youtube.com/watch?v=FrNqSLPaZLc" dir="ltr">Feynman Technique</a>. This technique boils down to using writing to make it easier to understand hard problems in math, science and other subjects.</p><p>Often, simply the act of writing down an explanation will resolve confusions. This is because the different components of the ideas are too large and numerous to stitch together into a completed understanding. Writing it down solves this capacity constraint and allows you to piece together a completed idea.</p><h2>Writing Doesn’t Record Your Thoughts, It Is Your Thinking</h2><p dir="ltr"><a href="https://jamesclear.com/" dir="ltr">James Clear</a>, a friend of mine and bestselling author, once told me that he doesn’t write to record his thoughts, but to figure out what he even thinks about a topic.</p><p>I feel the same way. Without writing, it isn’t simply that I would have tons of unrecorded ideas, bumping around in my skull, but that those ideas wouldn’t exist. They are created by the act of writing, much more so than they are being recorded.</p><p>If you don’t write regularly, the quality of your thinking suffers. Writing gives you access to an external brain, sharpens your ideas and makes your thoughts smarter.</p><BLOCKQUOTE><p>Consider this: Take whichever problem you find most challenging right now. It could be a life problem, relationships, academic or professional. Try writing about it every day for the next thirty days. You’ll be surprised at how many difficulties disappear once you’re able to write about it.</p></BLOCKQUOTE>',
    context:
      'It is often difficult to establish what we think before we have put it down in words. In many cases, we simply do not know what we want to say until we have tried to say it. After all, writing is thinking on paper, isn’t it?',
    created_at: '2022-03-04T13:29:42.519384',
    description:
      "Being able to think clearly is not easy. Working memory is limited, making thinking harder. Luckily, there's a tool to expand and improve your thinking.",
    id: 128074,
    image:
      'https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png',
    image_blurhash: 'L7S$ouof~qofs:RjozofM_WARjoz',
    image_compressed:
      'https://d3t70bohx4vuj7.cloudfront.net/4rmx_uKjNnM0usfA4nvOx0uBsPZs62EmeZnkrLUsxOM/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly93d3cuc2NvdHRoeW91bmcuY29tL2Jsb2cvd3AtY29udGVudC91cGxvYWRzLzIwMTgvMTEvbi1iYWNrLnBuZw',
    image_preview: 'https://preview.deepstash.com/a/128074-1646480500.png',
    source_subtype: 0,
    source_type: 0,
    status: 3,
    suggested_hashtags: [
      'problemsolving',
      'personaldevelopment',
      'write',
      'writing',
      'health',
    ],
    title: 'How to Think Better',
    top_reactions: [
      {
        reaction_id: 5,
        total_users: 5,
      },
      {
        reaction_id: 3,
        total_users: 1,
      },
      {
        reaction_id: 1,
        total_users: 1,
      },
    ],
    total_blocks: 15,
    total_comments: 0,
    total_likes: 0,
    total_reactions: 8,
    total_reads: 3963,
    total_saves: 1224,
    type: 0,
    updated_at: '2022-03-05T12:03:55.892107',
    url: 'https://www.scotthyoung.com/blog/2018/12/14/think-better/',
    user_data: {
      bio: '“An idea is something that won’t work unless you do.” - Thomas A. Edison',
      first_name: 'Xarikleia',
      has_profile: true,
      id: 1386670,
      image_preview: 'https://preview.deepstash.com/u/1386670-1658310265.png',
      last_name: '',
      photo:
        'https://d1dfxfqogsjixt.cloudfront.net/profile/1386670-1637023019.jpeg',
      photo_blurhash: 'LNQvwRj[_3j[~qfQM{fQD%fQWBfQ',
      subscription_type: 2,
      url: null,
      username: 'xarikleia',
    },
  },
  {
    author: null,
    blocks: [],
    content:
      '<div><a rel="">By Jessica Klein</a></div><div><span>3rd March 2021</span></div><div>Why does endlessly looking for bad news feel so strangely gratifying – and can we break the habit?</div><p>Article continues below</p><div>S</div><p>Since the beginning of the pandemic, Emily Bernstein, 29, has been scrolling and scrolling and scrolling. As a Los Angeles-based comedy writer, Bernstein needs to read through Twitter and news sites for material. But it’s not just her job that keeps her reading: it’s the compulsion of ‘doomscrolling’ – trawling through feeds without pause, no matter how bad the news is or how many trolls’ comments she reads.</p><p>“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?” says Bernstein.</p><p>It’s a question many doomscrollers have been asking themselves. There are multiple reasons why the urge to read may be so strong: the feeling of safety in knowledge, especially during difficult times; the design of social-media platforms that constantly refresh and boost the loudest voices; and, of course, the human fascination aspect. “It’s like not being able to look away when you see a car accident,” says Bernstein.</p><p dir="ltr">Beyond knowing intuitively that doomscrolling makes us feel awful, studies conducted during the pandemic have corroborated this, linking both anxiety and depression to <a href="https://link.springer.com/article/10.1007/s00406-020-01171-6" dir="ltr">the consumption of Covid-19 related media</a> and <a href="https://www.jmir.org/2020/6/e20185/pdf" dir="ltr">increased time spent on smartphones</a>. So, why do we keep endlessly scrolling ­– and why can the practice feel oddly soothing? And could there actually be surprising upsides to keeping our eyes locked on our feeds?</p><picture><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980twc.webp" type="image/webp"><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980twc.jpg" type="image/jpeg"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980twc.webp" type="image/webp"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980twc.jpg" type="image/jpeg"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980twc.webp" type="image/webp"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg" type="image/jpeg"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980twc.webp" type="image/webp"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980twc.jpg" type="image/jpeg"><img title="“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?&quot; – Emily Bernstein (Credit: Henrique Andrade)" src="https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg" alt="“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?&quot; – Emily Bernstein (Credit: Henrique Andrade)" width="687" height="386"></picture><p>“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?" – Emily Bernstein (Credit: Henrique Andrade)</p><p><strong>The ‘pleasure’ of doomscrolling</strong></p><p dir="ltr">Most of us spent some portion of 2020 doomscrolling ­– so much so that the Oxford English Dictionary <a href="https://pages.oup.com/ol/word-of-the-year-2020" dir="ltr">named it a word of the year</a>, and even added it to the dictionary.</p><p>But doomscrolling isn’t really a new human behaviour. Though the term seems to have entered the public lexicon in early 2020 around the start of Covid-19-related lockdowns, the public has long held the can’t-look-away-from-a-car-crash mentality Bernstein mentions when it comes to consuming news.</p><p>“The precursor to going online was that people would watch the 11 o’clock news, [which] was terrifying,” says Dean McKay, a Fordham University psychology professor who specialises in compulsive behaviour and anxiety disorders. That terror, when witnessed from the comfort of the viewer’s home, however, had a potentially calming effect. McKay describes the attitude as people acknowledging “things are pretty horrible, [but] I’m comfortable, so I\'m going to be able to sleep well tonight knowing that [I can feel good about] my station in life”.</p><p dir="ltr">McKay suggests doomscrolling could be a “modern equivalent”. But, unlike the 2300 news, it doesn’t stop at a fixed hour. During the uniquely uncertain and scary times of 2020, it’s no surprise that people like Bernstein scrolled well into the night. They <em dir="ltr">needed</em> information – at first because little was available about the virus, and then because they got sucked into the never-ending news cycle about it.</p><p>As Pamela Rutledge, director of the California-based Media Psychology Research Center, puts it, doomscrolling “really just describes the compulsive need to try and get answers when we’re afraid”.&nbsp; After all, we do have to assess whether new information constitutes a threat. “We are biologically driven to attend to that,” says Rutledge.</p><BLOCKQUOTE><h2>Doomscrolling really just describes the compulsive need to try and get answers when we’re afraid – Pamela Rutledge</h2></BLOCKQUOTE><p>“Unfortunately, journalism to some degree plays to that tendency,” she adds. Provocative headlines and stories draw in readers because they elicit fear and urgency ­­– as Bernstein says, “There’s a sense of, if I know all the latest news, I can better protect myself and my family.”</p><p>This feels reasonable – but most people scroll well past the point of ascertaining any valuable information. Bernstein, for instance, starts doomscrolling sessions by reading the news, but she regularly winds up scrolling through comment sections beneath the articles. “I know it\'s just going to be a bunch of psychopaths insulting other psychopaths,” she says. “I truly don\'t know why I do it.” She’s drawn, in a way, to the negativity.</p><p>McKay sees a possible evolutionary explanation for this. All human emotional states emerged because they were somehow adaptive. So, wanting to vicariously feel a certain emotion from reading news or comments, like anger or despair, may be a way for us to “practice evolved coping mechanisms” we’ve developed for managing negative life events. Being scared, for example, puts us on high alert, which is useful in dangerous situations. In that sense, says McKay, “[doomscrolling] is almost like an information and strategy gathering approach”.</p><p dir="ltr">So, yes, the pandemic has compounded this perceived need for information and news-induced emotions. But people who’ve been unable to socialise or work outside the home during the pandemic have also had more <em dir="ltr">time</em> to scroll. A German survey from late March and early April of 2020 showed a connection between “frequency, duration, and diversity of media exposure” to <a href="https://link.springer.com/article/10.1007/s00406-020-01171-6" dir="ltr">increased depression symptoms and both general and pandemic-related anxiety</a>. Researchers from Dartmouth College also found <a href="https://www.jmir.org/2020/6/e20185/pdf" dir="ltr">increased phone usage linked with more anxiety, depression and sedentary behavior</a>s among college students as Covid-19 concerns increased in March.</p><picture><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980tv3.webp" type="image/webp"><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980tv3.webp" type="image/webp"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980tv3.webp" type="image/webp"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980tv3.webp" type="image/webp"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980tv3.jpg" type="image/jpeg"><img title="When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)" src="https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg" alt="When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)" width="687" height="386"></picture><p>When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)</p><p><strong>The feed in your head</strong></p><p>For Rebecca Linton, 28, who works as a shoe prototyper in Denver, Colorado, doomscrolling during the pandemic has been about “trying to figure out what was going to happen next”, she says.</p><p>After the “novelty of being stuck inside and being able to craft all the time” during early lockdowns wore off, Linton found herself “consuming every possible news source about Covid, quarantine and the future that I possibly could”, she says. She often found herself getting sucked into the doomscrolling rabbit hole because she was trying to answer a specific question about what was going on – and that would just lead her to read different angles of the same story. It would also bring up entirely new questions she felt the need to answer, further lengthening her doomscrolling session and creating a self-perpetuating feed of bad news.</p><p>This behaviour of dwelling in a kind of endless feed can look a lot like Generalised Anxiety Disorder (GAD), says psychologist Jade Wu: “GAD is basically a Twitter feed of worries in your head.” Since GAD is associated with problems like muscle tensions, fatigue and depression, Wu says she imagines “similar effects” could happen to habitual doomscrollers.</p><p>“Doomscrolling is kind of like practicing having GAD,” she says. “If you run everyday, that\'s going to impact your muscles. If you doomscroll every day, that’s going to impact your psychology and your brain.”</p><BLOCKQUOTE><h2>Generalised Anxiety Disorder is basically a Twitter feed of worries in your head – Jane Wu</h2></BLOCKQUOTE><p>Doomscrolling also mimics gambling behaviours, because we don’t only scroll for bad news, but also anything uplifting. “We are hooked by the possibility of good news on the horizon,” Wu says (or even just finding a cute puppy video for some temporary relief). She compares doomscrolling, in that sense, to playing the slots. A gambler keeps pressing the lever in hope of winning, though it’s more likely they lose. Losing, for doomscrollers, means exposure to the same bad news, and the negative psychological and physical effects that come with it.</p><p>This “variable reinforcement schedule”, says Wu, “is the most addictive pattern of reward”. It’s why slot machines are designed the way they are – and social media feeds, too.</p><p><strong>‘The real world outside is not all trolls’</strong></p><p>If doomscrolling is slots-level addicting, and probably not the best for our mental health, how do we stop?</p><p>Rutledge stresses that awareness of our doomscrolling habits is the best way to quit them. For people on diets, for instance, keeping “food logs”, she says, is “one of the biggest predictors of success” for losing weight because it makes people aware of their current habits. The same could go for doomscrolling. Keep track of how much time you spend doing it to “identify the negative tendency”, Rutledge continues, “then you take steps to change it”.</p><p>Rutledge suggests setting a timer to stay alert to how long you’re spending on your phone, establishing a time at night when you put your phone down for the day, or having your partner remind you to turn it off.</p><p>That last suggestion works for Linton. Her partner has also got into doomscrolling in the past year, so they “actively support” each other’s efforts to stop, she says. “I find the most helpful thing is to get physical distance,” says Bernstein. “I’ll get off the internet, go on a walk and realise that the real world outside is not all trolls.”</p><picture><source media="(min-width:624px)" srcset="https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.webp" type="image/webp"><source media="(min-width:624px)" srcset="https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.jpg" type="image/jpeg"><source media="(min-width:485px)" srcset="https://ychef.files.bbci.co.uk/885x1280/p098cjvd.webp" type="image/webp"><source media="(min-width:485px)" srcset="https://ychef.files.bbci.co.uk/885x1280/p098cjvd.jpg" type="image/jpeg"><source media="(min-width:320px)" srcset="https://ychef.files.bbci.co.uk/720x900/p098cjvd.webp" type="image/webp"><source media="(min-width:320px)" srcset="https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg" type="image/jpeg"><img title="Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)" src="https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg" alt="Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)" width="592" height="740"></picture><p>Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)</p><p><strong>A future of… hopescrolling?</strong></p><p dir="ltr">McKay says he saw a report not long ago that we were <a href="https://www.cnn.com/2020/12/27/politics/anthony-fauci-biden-coronavirus-cnntv/index.html" dir="ltr">entering into the darkest days of the pandemic</a>, “but juxtaposed right next to it is [news] like, ‘here’s how many vaccines are getting rolled out’,” he says. “And suddenly, you have potentially less of a bleak picture.”</p><p>That slot machine analogy looks more favourable in this light. Maybe doomscrollers aren’t scrolling to seek out more doom and gloom – they’re doing what McKay tentatively calls “hopescrolling”.</p><p>Bernstein even heard the term “joyscrolling” used in recent months, “like on certain days that were particularly great… people were like, ‘I can’t stop joyscrolling!’”.&nbsp;</p><p>A day of scrolling through positive news can’t necessarily erase or counteract the habits we’ve formed from months of doomscrolling and their negative effects on our mental wellbeing. However, understanding that scrolling through good news brings us joy could help make us more aware of how our online behaviour affects our emotional state, which Rutledge says is the key to changing our behaviours. Linton, for one, has blocked people who she’s realised are “not bringing valuable information” to her social feeds and has tried to curate her Instagram so it’s full of accounts with more positive content – the kind she can feel good scrolling through.</p><p>“I think it\'s unrealistic to say one day Covid will be over, and I\'m never going to [doomscroll] again,” says Bernstein. “I do think it\'ll decrease, but that\'s also a thing I realised – I have to put in the work to do that.”</p>',
    context: null,
    created_at: '2021-03-06T21:05:04.888894',
    description: 'bbc.com',
    id: 58202,
    image: 'https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg',
    image_blurhash: null,
    image_compressed:
      'https://d3t70bohx4vuj7.cloudfront.net/xFwfzSytQ8ldxhsWcY2Q-R7p9pfCRX4w0A8JajW8fTc/resize:fill:500:0/gravity:sm/aHR0cHM6Ly95Y2hlZi5maWxlcy5iYmNpLmNvLnVrLzk3Nng1NDkvcDA5ODB0d2MuanBn',
    image_preview: 'https://preview.deepstash.com/a/58202-1620429982.png',
    images: [
      'https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg',
      'https://ychef.files.bbci.co.uk/1600x900/p0980twc.webp',
      'https://ychef.files.bbci.co.uk/1600x900/p0980twc.jpg',
      'https://ychef.files.bbci.co.uk/1280x720/p0980twc.webp',
      'https://ychef.files.bbci.co.uk/1280x720/p0980twc.jpg',
      'https://ychef.files.bbci.co.uk/976x549/p0980twc.webp',
      'https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg',
      'https://ychef.files.bbci.co.uk/624x351/p0980twc.webp',
      'https://ychef.files.bbci.co.uk/624x351/p0980twc.jpg',
      'https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg',
      'https://ychef.files.bbci.co.uk/1600x900/p0980tv3.webp',
      'https://ychef.files.bbci.co.uk/1600x900/p0980tv3.jpg',
      'https://ychef.files.bbci.co.uk/1280x720/p0980tv3.webp',
      'https://ychef.files.bbci.co.uk/1280x720/p0980tv3.jpg',
      'https://ychef.files.bbci.co.uk/976x549/p0980tv3.webp',
      'https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg',
      'https://ychef.files.bbci.co.uk/624x351/p0980tv3.webp',
      'https://ychef.files.bbci.co.uk/624x351/p0980tv3.jpg',
      'https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg',
      'https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.webp',
      'https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.jpg',
      'https://ychef.files.bbci.co.uk/885x1280/p098cjvd.webp',
      'https://ychef.files.bbci.co.uk/885x1280/p098cjvd.jpg',
      'https://ychef.files.bbci.co.uk/720x900/p098cjvd.webp',
      'https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg',
    ],
    source_subtype: 0,
    source_type: 4,
    stash_published_in: {
      description: null,
      emoji: '🌻',
      id: 678357,
      image: null,
      image_compressed: null,
      image_preview: 'https://preview.deepstash.com/s/678357-1620474999.png',
      name: 'Self Improvement',
      thematic: false,
      topics: [],
    },
    status: 3,
    title: "The darkly soothing compulsion of 'doomscrolling'",
    top_reactions: [
      {
        reaction_id: 2,
        total_users: 18,
      },
    ],
    total_blocks: 7,
    total_comments: 0,
    total_likes: 24,
    total_reactions: 18,
    total_reads: 3741,
    total_saves: 664,
    type: 0,
    updated_at: '2021-03-08T16:15:00.123243',
    url: 'https://www.bbc.com/worklife/article/20210226-the-darkly-soothing-compulsion-of-doomscrolling',
    user_data: {
      bio: 'I share what I find online.',
      first_name: 'Yahya',
      has_profile: true,
      id: 861564,
      image_preview: 'https://preview.deepstash.com/u/861564-1620474181.png',
      last_name: 'Patel',
      photo: 'https://d1dfxfqogsjixt.cloudfront.net/profile/yahyap.png',
      photo_blurhash: 'LfLVz2xZ14V[E*%Lw}$%9~xG?Fbu',
      subscription_type: 2,
      url: null,
      username: 'yahyap',
    },
  },
];

// Collections
export const LANDING_PAGE_COLLECTIONS: UserStash[] = [
  {
    id: 70,
    name: 'How to Properly Read a Book',
    description: 'A guide on how to better read & digest a book.',
    emoji: '📘',
    ideaCount: 59,
    imageUrl: 'https://static.deepstash.com/collection/70.svg',
  },
  {
    id: 14,
    name: 'How to Be More Mindful',
    description: 'Getting started with mindfulness.',
    emoji: '🧘',
    ideaCount: 39,
    imageUrl: 'https://static.deepstash.com/collection/14.svg',
  },
  {
    id: 17,
    name: 'Managing Perfectionism',
    description: 'Or how to let go of being perfect.',
    emoji: '💯',
    ideaCount: 46,
    imageUrl: 'https://static.deepstash.com/collection/17.svg',
  },
  {
    id: 13,
    name: 'Handling Difficult People',
    description: 'How smart people handle difficult people.',
    emoji: '👥',
    ideaCount: 42,
    imageUrl: 'https://static.deepstash.com/collection/13.svg',
  },
  {
    id: 69,
    name: 'The Imposter Cure',
    description: "You need to shake the feeling that you're a fraud.",
    emoji: '😰',
    ideaCount: 46,
    imageUrl: 'https://static.deepstash.com/collection/69.svg',
  },
  {
    id: 10,
    name: 'Managing Time Like a Pro',
    description: 'Time management tips for a productivity master.',
    emoji: '⏰',
    ideaCount: 53,
    imageUrl: 'https://static.deepstash.com/collection/10.svg',
  },
  {
    id: 7,
    name: 'Think Outside the Box',
    description: 'Organize your thinking and boost your creativity.',
    emoji: '🥡',
    ideaCount: 31,
    imageUrl: 'https://static.deepstash.com/collection/7.svg',
  },
  {
    id: 11,
    name: 'Lifelong Learning 101',
    description: 'Or how to turn yourself into a super-learner.',
    emoji: '🎓',
    ideaCount: 44,
    imageUrl: 'https://static.deepstash.com/collection/11.svg',
  },
  {
    id: 12,
    name: 'Self-Made Billionaires Secrets',
    description: 'Change how you think about money and success.',
    emoji: '💵',
    ideaCount: 47,
    imageUrl: 'https://static.deepstash.com/collection/12.svg',
  },
  {
    id: 75,
    name: 'Inside The Mind of Elon Musk',
    description: "A deep dive into how Elon's brain works.",
    emoji: '🧠',
    ideaCount: 75,
    imageUrl: 'https://static.deepstash.com/collection/75.svg',
  },
];

export const PRODUCT_HUNT_COLLECTIONS: UserStash[] = [
  {
    id: 12,
    name: 'Lessons From Self Made Billionaires',
    description:
      'We bring you lessons from self-made billionaires to point you in the right direction',
    emoji: '💵',
    ideaCount: 47,
    imageUrl:
      'https://audio.deepstash.com/collections/lessons_from_self_made_billionaires.png',
  },
  {
    id: 19,
    name: 'Joining A New Team',
    description:
      'How to Collaborate, Build trust and other tips to create a smooth transition in your new endeavour',
    emoji: '🌱',
    ideaCount: 61,
    imageUrl: 'https://audio.deepstash.com/collections/joining_a_new_team.png',
  },
  {
    id: 75,
    name: 'Inside The Mind of Elon Musk',
    description:
      'Dig into this collection about Elon Musk to see how his brain works, the future he envisions for the world, and a lot more.',
    emoji: '🧠',
    ideaCount: 42,
    imageUrl: 'https://audio.deepstash.com/collections/elon_musk.png',
  },
  {
    id: 30,
    name: 'How to Sell Anything ',
    description:
      'Expert tips on how to tap into the human psyche and turn potential customers into actual ones',
    emoji: '👨‍💼',
    ideaCount: 81,
    imageUrl:
      'https://audio.deepstash.com/collections/how_to_sell_anything.png',
  },
  {
    id: 33,
    name: 'How To Build A Company',
    description:
      'A go-to guide, for entrepreneurs for building a company from the ground up.',
    emoji: '⚒',
    ideaCount: 115,
    imageUrl:
      'https://audio.deepstash.com/collections/how_to_build_a_company.png',
  },
  {
    id: 44,
    name: 'Leading in Product Management ',
    description:
      'Best Practices to Align Stakeholders, Guide Development Teams, and Create Value Together',
    emoji: '👥',
    ideaCount: 68,
    imageUrl:
      'https://audio.deepstash.com/collections/leading_in_product_management.png',
  },
  {
    id: 60,
    name: 'The Startup Collection',
    description:
      'From the drawing board to fruition: A comprehensive guide to Startups.',
    emoji: '🧑‍💻',
    ideaCount: 95,
    imageUrl:
      'https://audio.deepstash.com/collections/the_startup_collection.png',
  },
  {
    id: 68,
    name: 'Introduction to Web 3.0',
    description:
      'Web 3.0 is bigger than Blockchain and NFTs. Let us find out how the next phase of the internet unfolds.',
    emoji: '🌐',
    ideaCount: 36,
    imageUrl:
      'https://audio.deepstash.com/collections/introduction_to_web30.png',
  },
  {
    id: 39,
    name: 'The Psychology Of The Ultimate Entrepreneur ',
    description:
      'Mindsets, Philosophies, And Understandings Of Ultra Successful Entrepreneurs Like Elon Musk, Jeff Bezos and more',
    emoji: '🕴',
    ideaCount: 39,
    imageUrl:
      'https://audio.deepstash.com/collections/the_psychology_of_the_ultimate_entrepreneur.png',
  },
  {
    id: 23,
    name: 'Unlocking your Creative Potential',
    description:
      'Practical exercises, tools and concepts to help you develop and enhance your creative thinking ',
    emoji: '🖌',
    ideaCount: 38,
    imageUrl:
      'https://audio.deepstash.com/collections/unlocking_your_creative_potential.png',
  },
];
